const TOKEN_KEY = 'um_ui_token';
const REFRESH_TOKEN_KEY = 'um_ui_refresh_token';
const SELECTED_APP_KEY = 'um_ui_selected_app_id';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);

export const setToken = (token) => {
    if (token) localStorage.setItem(TOKEN_KEY, token);
};

export const setRefreshToken = (token) => {
    if (token) localStorage.setItem(REFRESH_TOKEN_KEY, token);
};

export const clearToken = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
};

// Persists the app selected in the top-of-page app dropdown so it stays
// selected across page navigation instead of resetting to the first app.
export const getSelectedAppId = () => localStorage.getItem(SELECTED_APP_KEY) || '';

export const setSelectedAppId = (appId) => {
    if (appId) {
        localStorage.setItem(SELECTED_APP_KEY, appId);
    } else {
        localStorage.removeItem(SELECTED_APP_KEY);
    }
};

// Picks the app to default the dropdown to: explicit query param wins, then the
// last app the user selected (if still in their app list), then the first app.
export const resolveDefaultAppId = (apps, queryAppId) => {
    if (queryAppId && apps.some((a) => a.app_id === queryAppId)) return queryAppId;
    const stored = getSelectedAppId();
    if (stored && apps.some((a) => a.app_id === stored)) return stored;
    return apps[0]?.app_id || '';
};

// Decode the is_portal_admin claim from the stored authZ JWT. Drives which apps the
// console loads and which portal-admin-only routes/nav are shown. Client-side gating
// is UX/defense-in-depth only — the backend remains the real enforcement.
export const getIsPortalAdmin = () => {
    const token = getToken();
    if (!token) return false;
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.is_portal_admin === true || payload.is_portal_admin === 1;
    } catch {
        return false;
    }
};
